export const backendHost = process.env.NODE_ENV === 'production'
	? 'doc.doriclub.kg'
	: 'doc.doriclub.kg'
// export const backendHost = 'dev.doclub.uz' // for dev
export const backendPath = 'api'

export default {
	backendHost,
	backendPath,
}
